import React, { Component, useEffect, useState, forwardRef } from "react";
import PropTypes from 'prop-types';
import store from "@/redux/store";

import { Editor } from 'react-draft-wysiwyg';
import '@/styles/wysiwyg/react-draft-wysiwyg.css';
import { EditorState, RichUtils, Modifier,convertToRaw, convertFromRaw, convertFromHTML, ContentState, Immutable, Draft   } from 'draft-js';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Map } from 'immutable';
import CustomOption from '@/controllers/WorkProces/star';
import {
  changeDepth,
  handleNewLine,
  blockRenderMap,
  getCustomStyleMap,
  extractInlineStyle,
  getSelectedBlocksType,
  insertNewUnstyledBlock
} from "draftjs-utils";
import { renderToString } from 'react-dom/server';


export class CBL extends Component {
  constructor(props) {
    super(props);
  }    
      render() {
    return (
      <div className="ssdff">YES hier gaan we<br/>
       {this.props['children']}
       </div>
    );
    }
}

const PPCEditorWithRef = forwardRef(({ ...props }, ref) => {
    const myProps = props;

    const data = (props['content']) ? props['content'] : '<p></p>';
    let [editorState, setEditorState] = useState(null);
    const [defEditorState, setDefEditorState] = useState(null);
if(editorState === null) {
    let editorStateT
    if(data && data != '') {
        const blocksFromHtml = htmlToDraft(data);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        editorStateT = EditorState.createWithContent(contentState);
    } else {
         editorStateT = EditorState.createEmpty();
    }
    if(defEditorState === null) {
//        setDefEditorState( draftToHtml(convertToRaw(editorStateT.getCurrentContent())) );
    }
    
    setEditorState(editorStateT);
}


const handleReturn=(event) => {
        // override behavior for enter key
        var newEditorState = null;
        if (event.keyCode === 13 && event.shiftKey) {
            // with shift, make a new block
            newEditorState = insertNewUnstyledBlock(editorState);
        } else if (event.keyCode === 13 && !event.shiftKey) {
            // without shift, just a normal line break
            //let currentContentState = editorState.getCurrentContent();
            //let selectionState = editorState.getSelection();
            newEditorState = RichUtils.insertSoftNewline(editorState);

            //newEditorState = EditorState.moveFocusToEnd(editorState);
            
        }
        if (newEditorState) {
            
            onEditorStateChange(newEditorState);
            
            setEditorState(newEditorState);
            return true;
        }
        return false;
    }
/*

const contentBlocks = convertFromHTML(data);


const sampleEditorContent = ContentState.createFromBlockArray(contentBlocks);
const editorStateT = EditorState.createWithContent(sampleEditorContent);

*/
//const [editorState, setEditorState] = useState(EditorState.createEmpty());

//console.log( EditorState.createWithContent(convertFromHTML(props.content)) );
//console.log( ( convertFromRaw( props.content )) );
//setEditorState( EditorState.createWithContent( convertFromRaw( props.content )) )

const getHTML: Function = () => {
return draftToHtml(convertToRaw(editorState.getCurrentContent()));    
}
    
const onEditorStateChange: Function = (editorState) => {
    
    const { blocks, entityMap } = convertToRaw(editorState.getCurrentContent());
    setEditorState(editorState);
//}
       //console.log( draftToHtml(convertToRaw(editorState.getCurrentContent())) );

    }
    
const onSaveHandler: Function = (event, editorState) => {
    if( props['onSaveHandler'] ) {
        let func = props['onSaveHandler'];
         
        func(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    }
    }    
    
    const customEntityTransformT: Function = (entity, text) => {
        return HTMLBlockRenderer(text);
    }

  const onBlurHandler = (event) => {
      
      if(props['setValue']) {
          //myProps["formState"]['isDirty'] = contentChanged; 
          let html = draftToHtml(convertToRaw(editorState.getCurrentContent()), {}, false, customEntityTransformT);
          let func = props['setValue']
          //if( defEditorState != html ) {
              let fieldKey = ((myProps['fieldKey'] && myProps['fieldKey'] != "") ? myProps['fieldKey']+"."+myProps['fieldName'] : myProps['fieldName']);
              console.debug( fieldKey, "fieldKey" )
          func(fieldKey, html, { shouldDirty: true} );
          console.debug(props['getValues']());
          func = props['formState']
          /*
          } else {
          let func = props['reset']
          let fieldName = props['fieldName'];
          let obj = {}
          obj[fieldName] = html;
              func(obj);
          }
        */
          
        }
      event.target.classList.remove('active');
      
  }
  /*
const blockRenderMap = Map({
  'header-two': {
    element: 'section',
    wrapper: <div />
  },
  'myblock': {
    // the docs use 'MyCustomBlock', but I changed it to 'atomic' to make it easier to follow.
    // element is used during paste or html conversion to auto match your component;
    // it is also retained as part of this.props.children and not stripped out
    element: 'p',
    wrapper: <CBL />
  },
  'unstyled': {
    element: 'div',
    wrapper: <div />
  },
  
});
*/
// Include 'paragraph' as a valid block and updated the unstyled element but
// keep support for other draft default block types
//const extendedBlockRenderMap = Draft.DefaultDraftBlockRenderMap.merge(blockRenderMap);

const HTMLBlockRenderer=((contentBlock) =>{
    return renderToString(<CBL >{contentBlock.text}</CBL>);
 });
/*
 
const myBlockRenderer=((contentBlock) =>{
  const type = contentBlock.getType();
//  
  if (type === 'myblock ') {
      return (<CBL/>);
    return {
      component: <CBL />,
      editable: true,
      props: {
        foo: 'bar',
      },
    };
  }
})
*/
    return (
  <Editor
    //ref={ref}
    //preventScroll={false}
    //customBlockRenderFunc={blockRenderMap}
//    blockRenderMap={blockRenderMap}
 //   blockRendererFn={myBlockRenderer}
    
    //customBlockRenderFunc={blockRenderMap}
    //customBlockRenderFunc={myBlockRenderer}
    //getHTML={getHTML}
    toolbarClassName={((typeof myProps['toolbarClass']) == "undefined" ? "ppc-editor-toolbar-absolute" : myProps['toolbarClass']) }
    wrapperClassName="ppc-wrapper col-span-12"
    editorClassName={"ppc-editor "+((myProps['className'] && myProps['className'] != "") ? myProps['className'] : "")}
    handleReturn={handleReturn}
    //onFocus={(event) => {event.target.classList.add('active');console.log(event)}}
    onBlur={(event) => onBlurHandler(event)}
    onEditorStateChange={onEditorStateChange}
    editorState={editorState}
    //toolbarCustomButtons={[<CustomOption />]}
    /*
toolbarCustomButtons={[
<button
              onClick={(event) => {onSaveHandler(event, editorState)}}
              className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 mb-2"
            >
              Opslaan
            </button>
                    ]}
                    */    
//    onFocus={(event) => {console.log(event)}}
//    onBlur={(event, editorState) => {console.log(editorState)}}    
    toolbarOnFocus={((typeof myProps['toolbarOnFocus']) == "undefined" ? true : myProps['toolbarOnFocus']) }
    toolbar={{
      options: ['inline', 'embedded', 'blockType', 'colorPicker', 'fontSize', 'fontFamily', 'remove'],
      inline: {
        options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'],
        bold: { className: 'bordered-option-classname' },
        italic: { className: 'bordered-option-classname' },
        underline: { className: 'bordered-option-classname' },
        strikethrough: { className: 'bordered-option-classname' },
        code: { className: 'bordered-option-classname' },
      },
      remove: { className: undefined, component: undefined },
colorPicker: {
    className: undefined,
    component: undefined,
    popupClassName: 'color-popup',
    colors: ['#0600ff'],
  },
        embedded: {
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    embedCallback: undefined,
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
 blockType: {
    inDropdown: true,
    options: ['Normal', 'Atomic', 'H1', 'H2'],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
        fontSize: {
        className: 'bordered-option-classname',
      },
      fontFamily: {
        className: 'bordered-option-classname',
      },
    }}
  />
    )
})

const PPCEditor = (({...props}, ref) => {
    return (<PPCEditorWithRef ref={ref} {...props}/>);
})

export default PPCEditor;